// extracted by mini-css-extract-plugin
export var container = "_2l-0";
export var error = "_2l-9";
export var label = "_2l-5";
export var light = "_2l-6";
export var md = "_2l-3";
export var sm = "_2l-2";
export var thin = "_2l-8";
export var thinBold = "_2l-7";
export var vertical = "_2l-4";
export var xs = "_2l-1";